import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@kizen/kds/Button';
import {
  PiChatSkeleton,
  useLoadingReveal,
} from 'ts-components/PiChat/PiChatSkeleton';
import { VisuallyHidden } from 'ts-components/PiChat/styles';

export interface ResumePendingPanelProps {
  qaPrefix: string;
  onClose: () => void;
  className?: string;
}

// Matches the chat panel's close control, so a slow lookup never traps it.
export const ResumePendingPanel: FC<ResumePendingPanelProps> = ({
  qaPrefix,
  onClose,
  className,
}) => {
  const { t } = useTranslation();
  const revealed = useLoadingReveal(true);
  return (
    <div
      className={className}
      style={{ padding: 15 }}
      aria-busy="true"
      data-qa-id={`${qaPrefix}-resume-pending`}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="text"
          color="tertiary"
          leftIcon="action-close"
          leftIconSettings={{
            size: 'sm',
            // KDS turns the icon tooltip off once the button has a label.
            tooltipEnabled: true,
            tooltipTitleOverride: '',
            tooltipDescriptionOverride: t('Close'),
            tooltipPosition: 'bottom',
          }}
          onClick={onClose}
          qa={{ id: `${qaPrefix}-resume-close` }}
        >
          {/* The tooltip is hover-only; this is the button's accessible name. */}
          <VisuallyHidden>{t('Close')}</VisuallyHidden>
        </Button>
      </div>
      <PiChatSkeleton revealed={revealed} />
    </div>
  );
};
